import React from 'react';

interface SplashPreviewProps {
  imageUrl: string | null;
  device: 'mobile' | 'tablet' | 'desktop';
}

const SplashPreview: React.FC<SplashPreviewProps> = ({ imageUrl, device }) => {
  const getDeviceClass = () => {
    switch (device) {
      case 'mobile':
        return 'w-[300px] h-[560px]';
      case 'tablet':
        return 'w-[320px] h-[620px]';
      case 'desktop':
        return 'w-[340px] h-[660px]';
      default:
        return 'w-[300px] h-[560px]';
    }
  };

  return (
    <div className="bg-gray-50 rounded-lg p-2 overflow-x-hidden">
      <div className="mb-3">
        <h3 className="text-lg font-semibold text-gray-900">Preview</h3>
        <p className="text-sm text-gray-600">See your changes here</p>
      </div>
      <div className="flex justify-center">
        <div className={`${getDeviceClass()} bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden mx-auto`}> 
          <div className="w-full h-full overflow-y-auto overflow-x-hidden">
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="Splash Preview"
                className="w-full h-auto block object-contain"
              />
            ) : (
              <div className="text-gray-500 text-sm flex items-center justify-center w-full h-full">
                Upload splash screen to preview
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashPreview;


